import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Message } from '@getro/rombo';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Download } from 'lucide-react';
import toast from 'react-hot-toast';

import { useExportJobAlertSubscribersMutation } from 'services/organizationsV2';
import { activeNetworkSelector } from 'redux/selectors';
import { trackEvent } from 'helpers/analytics';

const ExportJobAlertSubscribers = ({ ...rebassProps }) => {
  const activeNetwork = useSelector(activeNetworkSelector);
  const [exportJobAlertSubscribers, { isLoading: isExportingJobAlertSubscribers }] =
    useExportJobAlertSubscribersMutation();

  return (
    <Box {...rebassProps}>
      <Flex sx={{ flexDirection: 'column', gap: '16px' }}>
        <Flex sx={{ flexDirection: 'column', gap: '8px' }}>
          <Text
            sx={{
              color: 'text.dark',
              fontFamily: 'Silka',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '140%',
            }}
          >
            Job alerts subscribers export
          </Text>
          <Text
            sx={{
              color: 'text.main',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '20px',
            }}
          >
            Download list of job alert subscribers and their preferences in a CSV file.
          </Text>
        </Flex>
        <Message>
          Get a list of users who are (or have been) subscribed to jobs in your job board. Use this list to betterq
        </Message>
        <Box>
          <Button
            size="small"
            variant="secondary"
            onClick={() =>
              exportJobAlertSubscribers(activeNetwork.id).then((res) => {
                const isError = res.error;
                toast(
                  isError
                    ? 'There was an unexpected error, try again or send us a chat.'
                    : 'Export in progress — we’ll email it to you in a few minutes.',
                  { icon: isError ? 'error' : 'success', id: 'export-csv-success' },
                );

                if (!isError) {
                  trackEvent('job_seeker_notifications:subscribers_dump_request', {
                    networkId: activeNetwork.id,
                    isNetworkAdmin: activeNetwork.isManager,
                  });
                }
              })
            }
            loading={isExportingJobAlertSubscribers}
          >
            <Flex alignItems="center" sx={{ columnGap: '10px' }}>
              <Box as={Download} height="16px" width="16px" aria-hidden="true" />
              Export subscribers
            </Flex>
          </Button>
        </Box>
      </Flex>
    </Box>
  );
};

export default ExportJobAlertSubscribers;
